/* global IS_TOUCH, _E, dinStyle, EP, nf */
//


(function () {



    // DRAG 
    var DO = {};
    function initDO(e, OPT = {}) {


        if (e.altKey) {
            return   // allow select string in draggable elements
        }
        if (e.which !== 1) {
            return;  // drag numai pt left-click;
        }
        if (OPT.before) { // in functia before am this obiectul de configurare OPT in care de ex pot schimba conditionat targetul sau comportamentul dragului
            if (OPT.before(e))
                return; // conditionally stop
        }
        var $ = e.currentTarget, hot = e.target;
        if (hot.tagName === 'INPUT') { // prevent #INPUT to drag parent instead of focusing  -- si textarea si x-aim .....
            hot.focus();
            hot.hasA("type", "checkbox") && IS_TOUCH && hot.click();
            return;
        }
        if (hot.tagName === 'GSHUP') { // allow show bubbles
            return;
        }



        $.fire("dragstart");
        //  t0 = t1 = performance.now();
        // drag element poate fi self ,parent , taget_element, sau o clona gost -- pt svg elements 
        DO.dragElm = OPT.target || $;
        // console.log("DRAG_ELEMENT", OPT.target)
        DO.zIndex = DO.dragElm.computed("zIndex"); // !!!BAC>>> pare sa accelereze
        DO.tx = 0;
        DO.ty = 0;
        DO.trf_base = DO.dragElm.style.transform.replace(/translate\(.*?\)/, function (x) {
            var T = x.match(/[-\d\.]+/gim);
            DO.tx = +T[0];
            DO.ty = +T[1];
            return '';
        });

        DO.mX = e.clientX;
        DO.mY = e.clientY;
        // !!! admit  ca am numai scale 2D si scaleX===scaleY
        DO.inhertited_scale = calculate_inherited_scale(DO.dragElm);


        window.addEventListener('pointermove', moveDO, false);

        e.preventDefault(); // omoara blur pt inputuri
        e.stopPropagation();// !!!! allow drag an element hosted by a draggable parent -- without draging both;

        DO.dragElm.on("touchstart", prevent_touch);

    };

    var t0, t1, dx, dy, x0, x, y0, y, ticking = false;

    function foo(elm) {
        setTimeout(() => {
            elm.fire("moved");
        }, 0);
    }

    function moveDO(e) {
        e.preventDefault(); // evit selectie de text peste care trece 
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(() => {
                dx = (e.clientX - DO.mX) / DO.inhertited_scale;
                dy = (e.clientY - DO.mY) / DO.inhertited_scale;
                // t0 = t1;
                // t1 = performance.now();
                x0 = x;
                y0 = y;
                x = DO.tx + dx;
                y = DO.ty + dy;

                if (DO.dragElm.cage) {
                    if (DO.dragElm.cage.left !== undefined)
                        x = Math.max(x, DO.dragElm.cage.left);
                    if (DO.dragElm.cage.right !== undefined)
                        x = Math.min(x, DO.dragElm.cage.right);
                    if (DO.dragElm.cage.top !== undefined)
                        y = Math.max(y, DO.dragElm.cage.top);
                    if (DO.dragElm.cage.bottom !== undefined)
                        y = Math.min(y, DO.dragElm.cage.bottom);
                }
                // keep path
                if (DO.dragElm.path) {
                    if (Math.abs(dx) >= Math.abs(dy)) {
                        if (DO.dragElm.path.dir !== undefined)
                            y = DO.dragElm.path.dir(x);
                    }
                    else {
                        if (DO.dragElm.path.rev !== undefined)
                            x = DO.dragElm.path.rev(y);
                    }
                }
                let ELM = DO.dragElm;
                ELM.style.transform = "translate(" + x + "px," + y + "px) " + DO.trf_base; // put translation first !!!
                //foo.dobounce(100)(ELM)
                //foo.debounce(10)(ELM);
            });
            //ELM.fire("drag", { drag: { dx: dx, dy: dy } });
            setTimeout(() => ticking = false, 0); // !!!BAC>>> era 5 si parea sa mearga greoi!!!
        }
    };


    function prevent_touch(ev) {
        ev.preventDefault();
    }

    function disableDragWatch(e) {
        if (!DO.dragElm)
            return;
        try {
            DO.dragElm.oo.active = false;
        } catch (e) {
        }
        DO.dragElm.fire("dragend");

        DO.dragElm.off("touchstart", prevent_touch);
        document.onselectstart = null;
        window.removeEventListener('pointermove', moveDO, false);
    }

    window.addEventListener('pointerup', disableDragWatch, false);

    function calculate_inherited_scale(elm) {
        var s = 1, p = elm.parent, cs;
        while (p !== document.body) {
            cs = getComputedStyle(p).transform;
            var A = /matrix\(([^,]*),/.exec(cs);
            if (A) {
                s *= +A[1];
            }
            p = p.parent;
        }
        return s;
    }

    EP.drag = function (opt) {
        this.drag_hnd && this.undrag();
        this.drag_hnd = function (e) {
            initDO(e, opt);
        };
        this.on('pointerdown', this.drag_hnd, false);

        return this;
    };
    EP.undrag = function () {
        this.off('pointerdown', this.drag_hnd, false);
        this.off("touchstart", ev => {
            ev.preventDefault();
        });
        return this;
    };

    EP.dragParent = function () {
        this.drag({ target: this.parent });
        return this;
    };
    EP.undragParent = EP.undrag;
})();



//bind to a cage	-- ref is a DOM element 
function bindCage(elm, ref) {
    elm.cage = {};
    elm.cage.top = ref.y - elm.y;
    elm.cage.bottom = elm.cage.top + ref.offsetHeight - elm.offsetHeight;
    elm.cage.left = ref.x - elm.x;
    elm.cage.right = elm.cage.left + ref.offsetWidth - elm.offsetWidth;
}







// ZOOM 
function zoom(e) {
    if (e.altKey) {   // scroll pagina 
        return;
    }
    if (!e.metaKey) { // zoom even overflow element under
        let path = e.composedPath();
        for (let i = 0; i < path.length - 1; i++) {
            if (path[i] === this || path[i] === this.zoom_conf.allow_childs_scroll_inside) {
                break;
            }
            let o = path[i].overflow;
            if (o.w || o.h) {
                if (path[i].tagName !== 'foreignObject') {  // e calculat gresit deci il ignor
                    return;
                }
            }
        }
    }
    e.preventDefault();

    //
    requestAnimationFrame(() => {    //!!!BAC ---   arrow function lasa this sa fie elementul care capteaza wheel       din addEventListener    ---  
        var CONF = this.zoom_conf;

        if (CONF.before) { // in functia before am this obiectul de configurare OPT in care de ex pot schimba conditionat targetul sau comportamentul dragului
            if (CONF.before(e))
                return; // conditionally stop
        }
        var STAGE = CONF.target, // zoom element inside the container 
            G = STAGE.geometry,
            sense = CONF.sense || -1,
            MIN = CONF.min || .125, // min zoom
            MAX = CONF.max || 6, // max zoom
            alfa = CONF.alfa || (0.003 + Math.pow(G.scale, 1) * .005), // multiply coeficient
            delta = sense * Math.sign(e.deltaY) * Math.min(Math.abs(e.deltaY), 10), //limitare pas whell
            //delta = sense * Math.sign(e.deltaY) * (Math.log(Math.abs(e.deltaY))+1)*5, //limitare pas whell
            scale_to = G.scale + delta * alfa;

        // Restrict scale_to
        if (scale_to > MAX || scale_to < MIN) {
            return;
        }
        // Pan 
        // punct_imaginar cu coordonatele X0,Y0 (adica exact sub mouse pointer)
        var X0 = e.clientX,
            Y0 = e.clientY,
            Ox = G.x + G.w / 2, // pozitia x a punctului de transformOrigin
            Xc = Ox - (Ox - X0) * scale_to / G.scale, // dupa schimbarea scalei noua pozitie a punctului imaginat  fata de centru este 
            dx = Xc - X0, // deplasarea pe orizontala  -- datorata zoom trebuie compensata de translatarea intregii scene a.i. punctul imaginar sa ramana sub mouse pointer
            Oy = G.y + G.h / 2,
            Yc = Oy - (Oy - Y0) * scale_to / G.scale,
            dy = Yc - Y0;

        var M = G.matrix;

        //setare scaleXY
        STAGE._zoom_ = M[0] = M[5] = scale_to;
        // compensare din traslateXY
        M[12] -= dx;
        M[13] -= dy;
        STAGE.matrix = M;
        CONF.cb && CONF.cb(scale_to);
        STAGE.fire("zoom", { matrix: M })
    });
}

EP.zoom = function (opt = {}) {
    let $ = this;
    if (!opt.hasOwnProperty("target")) {
        opt.target = $;
    }
    $.zoom_conf = opt;
    if (!opt.allow_childs_scroll_inside instanceof Element) {
        opt.allow_childs_scroll_inside = $;
    }
    $.on("wheel", zoom);

    /* ma ajuta sa optimizez codul pt a permite scroll implicit pe descendenti */
    // $.on("scroll", set_scrolling_child_prop, true); // scroll must be captured
    //$.on("scrollend", set_scrolling_child_prop, true);
};

function set_scrolling_child_prop(ev) {
    this.scrolling_child = ev.type === "scroll" ? true : false
}

EP.zoom_off = function () {
    this.off("wheel", zoom);

    //$.off("scroll", set_scrolling_child_prop, true); // scroll must be captured
    //$.off("scrollend", set_scrolling_child_prop, true);
};








// CONTROLER	 
function Controler(lever, type, propRange, handler) {
    this.lever = lever;
    this.type = type;
    this.propRange = propRange;

    var H;
    this.trig('handler', function (v) {
        H = v;
    });
    this.handler = handler;

    this.init = function () {
        this.lever.isLever = this.type;
        var i_min, i_max;
        if (this.type === 'horizontal') {
            i_min = this.lever.cage.left || 0;
            i_max = this.lever.cage.right || 100;
        }
        else {
            i_min = this.lever.cage.top || 0;
            i_max = this.lever.cage.bottom || 100;
        }
        var a = (this.propRange[1] - this.propRange[0]) / (i_max - i_min);
        var b = this.propRange[0] - i_min * a;
        this.lever.trig('i', function (v) {
            var sv = v * a + b;
            H(sv);
        });
    };

}




// to do : dragPath(elm) - relation between x/y to restrict posible values

// KNOB CONTROLER
dinStyle._(_txt("/* KNOB OBJECT */\n" +
    "[Knob_button]{display:inline-block;z-index:2;background:gray;position:relative;transition:background-color .2s }" +
    "[Knob_button]:hover{background:#444}" +
    "[Knob_button]:active{background:black !important;box-shadow:0px 0px 2px black}" +
    "[Knob_indicator]{position:absolute;border:2px solid white;margin-top:5px}"
));

function Knob(place_to_append) {
    var T = this;
    Object.defineProperty(T, 'type', { value: "Knob", enumerable: true });
    T.button = _E().setA('Knob_button');
    T.button.oo = T;
    (place_to_append || document.body)._(T.button);
    T.indicator = _E().css("position:absolute;border:2px solid white;margin-top:5px");//.setA('Knob_indicator');
    T.button._(T.indicator);

    T.trig('radius',
        function (x) {
            var r = parseInt(x);
            T.button.css("border-radius:" + r + "px;width:" + 2 * r + "px;height:" + 2 * r + "px;");
            T.indicator.css("height:" + r / 3 + "px");
            T.indicator.centerW();
        }
    );
    T.radius = 30;

    T.trig('color',
        function (s) {
            T.button.style.backgroundColor = s;
        }
        , "");

    T.min = -120;
    T.max = 120;
    T.step = 1;

    var a, b;
    T.trig('range',
        function (ar) {
            a = (ar[1] - ar[0]) / (T.max - T.min);
            b = ar[0] - T.min * a;
        }
    );
    var q;
    T.gost("quantize", function () {
        if (T.alfa != q)
            T.alfa = q;
    });
    T.jump = 0;
    T.trig("alfa", function (x) {
        if (this.disabled == 1)
            return;
        if (typeof T.min == 'number')
            x = Math.max(T.min, x);
        if (typeof T.max == 'number')
            x = Math.min(T.max, x);
        //if(parseFloat(T.step))
        q = sign(x) * Math.round(Math.abs(x) / T.step) * T.step;
        if (T.jump)
            x = q;
        if (T.active) {
            T.button.rotate(x);
        }
        else {
            T.quantize();
            T.button.spin(x);
        }

        if (T.action) {
            switch (gettype(T.range)) {
                case "Array":
                    {
                        x = a * x + b;
                    }
                    break;
                case "Function":
                    {
                        x = T.range(x);
                    }
            }
            T.action(x);
        }
    }, 0);
    T.trig("disabled", function (x) {
        !!x ? T.button.setA("disabled") : T.button.remA("disabled");
    });
    T.reset = function () {
        T.alfa = 0;
        T.indicator.centerW();
    };
    T.action = null;
    T.button.AEL("mousedown", activate_controler, false);
    T.button.on("t2m");
    T.button.on('dblclick dbltap', T.reset);
    T.active = true;
    T.alfa = 0;
    T.active = false;
}
Knob.prototype = {};//function(){}

Knob.prototype.toString = function () {
    return "Knob";
};//Knob.prototype.limit=function(){dn(1)}

// FADER  CONTROLER
dinStyle._(_txt("/* FADER OBJECT */\n" +
    "[Fader_rail]{position:relative;border-top:6px solid gray;}" +
    "[Fader_indicator]{width:18px;height:18px;border-radius:9px;position:absolute;margin-left:-7px;margin-top:-12px;background:rgba(255,0,0,.7)}" +
    "[Fader_indicator]:active{background:black !important;box-shadow:0px 0px 3px black}"
));
function Fader(place_to_append) {
    var T = this;
    Object.defineProperty(T, 'type', { value: "Fader", enumerable: true });
    T.trig('size', function (x) {
        T.rail.style.width = parseInt(x) + 'px';
    });
    T.rail = _E().setA('Fader_rail');
    T.rail.oo = T;
    (place_to_append || document.body)._(T.rail);
    T.indicator = _E().setA('Fader_indicator');
    T.indicator.oo = T;
    T.indicator.adjust = function () {
        this.style.marginLeft = "-" + parseInt(this.computed('width')) / 2 + 'px';
    };
    var origin = _E().css("position:absolute;top:0;left:0");
    T.rail._(origin);
    T.step = 1;
    T.size = 200;
    T.rail._(T.indicator);
    T.indicator.adjust();
    T.active = false;
    var poz = 0;
    Object.defineProperty(T,
        'poz',
        {
            enumerable: true,
            configurable: true,
            get: function () {
                return poz;
            },
            set: function (x) {
                poz = x = Math.min(Math.max(0, x), 100);
                if (parseFloat(T.step))
                    x = Math.round(x / T.step) * T.step;
                T.active ? T.indicator.style.left = x + "%" : T.indicator.morf("left", x + "%");
                if (T.action) {
                    switch (gettype(T.range)) {
                        case "Array":
                            {
                                x = (T.range[1] - T.range[0]) * x / 100 + T.range[0];
                            }
                            break;
                        case "Function":
                            {
                                x = T.range(x);
                            }
                    }
                    T.action(x);
                }
            }
        }
    );
    T.trig("alfa", function (x) {
        T.rail.rotate(parseInt(x));
    });
    T.quantize = function () {
        return;
    };
    T.indicator.on("click", activate_controler);
    T.indicator.on("click", function (e) {
        SEP(e);
    });
    T.rail.on("click", activate_controler
        //        function(e){
        //		var dx=e.pageX-getX(origin);
        //		var dy=e.pageY-getY(origin);
        //		var p=Math.sqrt(dx*dx+dy*dy)/T.size*100;
        //		T.poz=p;
        //		}
        , false);
}







//rez=function(x){Q('h1')[0].innerHTML=x} 
activate_controler = function (e) {
    if (this.oo.disabled == 1)
        return;
    document.onselectstart = function () {
        return false;
    };//prevent selections for IE
    e.preventDefault();// prevent selections for FF
    SEP(e);
    var $ = this;// the button div
    $.oo.active = true;
    var mX0 = e.clientX, mY0 = e.clientY; // initial mouse position

    switch ($.oo.type) {

        case 'Knob':
            {
                var Cx = getX($) + $.offsetWidth / 2 - pageXOffset;
                var Cy = getY($) + $.offsetWidth / 2 - pageYOffset;
                var calculate = function (e) {
                    var x = e.clientX - Cx, x0 = mX0 - Cx, y = e.clientY - Cy, y0 = mY0 - Cy;
                    if (y == 0 || y0 == 0)
                        return;
                    var d = (Math.atan(y / x) - Math.atan(y0 / x0)) * 180 / Math.PI;
                    if (Math.abs(d) > 90) {
                        d = -sign(d) * 180 + d;
                    } // quadrature corection		
                    var ang = $.oo.alfa + d;
                    $.oo.alfa = ang;
                    mX0 = e.clientX;
                    mY0 = e.clientY;
                };
            }
            break;
        case 'Fader':
            {
                try {
                    var tmp = $.oo.rail.computed(if_brac('transform')).split('(')[1].split(',')[0];
                    var ang = Math.acos(tmp);
                } catch (e) {
                    ang = 0;
                }
                var calculate = function (e) {
                    var x = e.clientX, y = e.clientY;
                    var dx = x - mX0, dy = y - mY0;
                    var d = (dx * Math.cos(ang) + dy * Math.sin(ang)) * 100 / $.oo.size;
                    var poz = $.oo.poz + d;
                    $.oo.poz = poz;
                    mX0 = x;
                    mY0 = y;
                };
            }
            break;
    }



    window.AEL('mousemove', calculate);

    var deactivate = function () {
        window.REL('mousemove', calculate);
        window.REL('mouseup', deactivate);
        document.onselectstart = null;
        $.oo.quantize();
        $.oo.active = false;
    };

    window.AEL('mouseup', deactivate);
};


